<div class="modal-header always-enabled">
  <h4 class="modal-title" id="modal-title">
    <ng-container>
      <i class="fa-light fa-exclamation-triangle fa-fw me-1 text-info" aria-hidden="true"></i>
      {{ title }}
    </ng-container>
  </h4>
  <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-3">
    <button type="button" class="btn-close m-0" aria-label="Close button" aria-describedby="modal-title"
            (click)="callback(null)"></button>
  </div>
</div>
<div class="modal-body">
  @if (data.body) {
    <ng-container [ngTemplateOutlet]="data.body"></ng-container>
  } @else {
    @if (data.message) {
      <p>{{ data.message }}</p>
    }
    @if (data.beforePointsMessage) {
      <p>{{ data.beforePointsMessage }}</p>
    }
    @for (point of points; track point) {
      <ul>
        <li [innerHTML]="point"></li>
      </ul>
    }
    @if (data.afterPointsMessage) {
      <p>{{ data.afterPointsMessage }}</p>
    }
    @if (data.withReason) {
      <app-form-group label="Reason">
        <input class="form-control" required placeholder="Enter reason" [(ngModel)]="data.reason">
      </app-form-group>
    }
    @if (data.withChosableReason) {
      @if (data.chosableMessage) {
        <p>{{ data.chosableMessage }}</p>
      }
      @if (data.withChosableReason) {
        <app-form-group>
          <label for="for-radio">Reason</label>
          <app-radio
            [(ngModel)]="data.reason"
            [options]="data.chosableReasons"
            [formatter]="data.chosableReasonFormatter"
            id="for-radio"
            [inline]="true" required></app-radio>
        </app-form-group>
      }
    }
  }
</div>
<div class="modal-footer">
  <!-- Button style -->
  <ng-container>
    <button type="button" [appAutoFocus]="true" [autoFocusInOverlay]="true"
            class="btn btn-outline-secondary"
            (click)="callback(true)">{{ confirmText }}
    </button>
  </ng-container>
</div>
